import React from 'react'
import css from './post.scss';
import user from '../../assets/images/user.svg'
import Frame from '../frames/frame';

const Avatar = (props) => {
    return (
        <img className={css.avatar} src={props.img ? props.img : user} alt="ava" />
    )
}

class Post extends React.Component {
    constructor(props) {
        super(props);
        this.state = { clipContent: true };
    }

    onClick(event) {
        event.preventDefault();
        this.setState((state) => ({ ...state, clipContent: !state.clipContent }))
    }

    isLongContent() {
        return this.props.content.length >= 252
    }

    render() {
        console.log(this.state);
        return (
            <Frame white>
                <div className={css.root}>
                    <div className={css.header}>
                        <Avatar img={this.props.authorAvatar} />
                        <div className={css.header__metadata}>
                            <span className={css.header__metadata__author}>{this.props.author}</span>
                            <span className={css.header__metadata__date}>{this.props.date}</span>
                        </div>
                    </div>
                    <article className={`${css.content} ${this.state.clipContent ? css.clip : ""}`}>
                        {this.props.content}
                        {this.isLongContent() ? <button className={`${css.seeMore} ${!this.state.clipContent ? css.seeLess : ""}`} onClick={(e) => this.onClick(e)}>{this.state.clipContent ? "... смотреть больше" : "<"}</button> : ""}
                    </article>
                    <div className={css.footer}>

                    </div>
                </div>
            </Frame>
        )
    }
}

export default Post;